import React from 'react';
import NavItem from './NavItem';
import {
  AILogo,
  PasswordProfileIcon,
  PaymentsIcon,
  Magaphone2Icon,
  CalendarIcon,
  TicketIcon,
  EnvelopeIcon,
} from 'assets/icons';
import UnreadMessagesCount from './UnreadMessagesCount';

/**
 * Sidebar shown to Admins / Accountants who belong to the
 * “Support Back Office” department.
 */
export default function SupportMenu() {
  return (
    <>
      <NavItem
        icon={TicketIcon}
        name="Tickets"
        path="/dashboard/tickets"
        className="custom-menu-item"
      />
      <NavItem
        icon={CalendarIcon}
        name="Upcoming Dates"
        path="/dashboard/upcomingDates"
        className="custom-menu-item"
      />
      <NavItem
        icon={EnvelopeIcon}
        name="Messages"
        path="/dashboard/messages"
        className="custom-menu-item"
        suffix={<UnreadMessagesCount />}
      />
      <NavItem
        icon={AILogo}
        name="AI Mito"
        path="/dashboard/ai-mito"
        className="custom-menu-item"
      />
      <NavItem
        icon={PasswordProfileIcon}
        name="Privacy Policy"
        path="/dashboard/privacy-policy"
        className="custom-menu-item"
      />
      <NavItem
        icon={PaymentsIcon}
        name="Promo Codes"
        path="/dashboard/promocodes"
        className="custom-menu-item"
      />
      <NavItem
        icon={Magaphone2Icon}
        name="Announcements"
        path="/dashboard/announcements"
        className="custom-menu-item"
      />
    </>
  );
}
